// extracted by mini-css-extract-plugin
export default {"container":"TextWithBg_container__JW2s7","conclusionSec":"TextWithBg_conclusionSec__3yryr","highlightedText":"TextWithBg_highlightedText__Cyobu"};